function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

const Category = require('../entities/category');

function _call(body, then, direct) {
  if (direct) {
    return then ? then(body()) : body();
  }

  try {
    var result = Promise.resolve(body());
    return then ? result.then(then) : result;
  } catch (e) {
    return Promise.reject(e);
  }
}

const PagedList = require('../entities/paged-list');

const diff = require('../utils/diff');

const {
  strinct,
  strList
} = require('../utils/serialize');

const getPropertyLocales = require('../utils/get-property-locales');

const CategoryLocalizerFactory = require('../entities/category-localizer');

const CategoryLocalizationDictionary = require('../entities/category-localization-dictionary');

const fields = ['id', 'name', 'shortName', 'images', 'parentCategoryId'];
/*:: type SearchParams = { query: String, leafOnly: boolean, locale: Array<String> };*/

/*:: type SearchResults = Promise<PagedList<Category>>;*/

class CategoryRepo {
  constructor(client
  /*: ApiClient*/
  ) {
    this.client = client;
  }

  search({
    /*: SearchParams*/

    query,
    leafOnly,
    locale
  } = {})
  /*: SearchResults*/
  {
    const _this = this;

    return _call(function () {
      const url = `/categories/search`;
      const searchFields = ['id', 'name', 'parentCategoryId'];
      const params = {
        limit: 40,
        q: strinct(query)
      };
      if (locale) params.locale = strList(locale);
      const req = new _this.client.Request(url, params, searchFields);
      req.parse = Category.fromJson;

      if (leafOnly) {
        req.transform = (categories
        /*: PagedList<Category>*/
        ) => categories.copy(items => items.filter(c => c.isLeaf));
      }

      return _await(_this.client.get(req));
    });
  }

  list()
  /*: SearchResults*/
  {
    const _this2 = this;

    return _call(function () {
      const req = new _this2.client.Request(`/categories`, {
        limit: 50
      }, fields);
      req.parse = Category.fromJson;
      return _await(_this2.client.get(req));
    });
  }

  listAll()
  /*: SearchResults*/
  {
    const _this3 = this;

    return _call(function () {
      return _await(_this3.list().then(_this3.client.pagination.loadRest));
    });
  }

  details(categoryId
  /*: string*/
  )
  /*: Promise<Category>*/
  {
    const _this4 = this;

    return _call(function () {
      const req = new _this4.client.Request(`/categories/${categoryId}`, {}, fields);
      req.parse = Category.fromJson;
      return _await(_this4.client.get(req));
    });
  }

  create(category
  /*: Category | Category*/
  )
  /*: Promise<Category>*/
  {
    const _this5 = this;

    return _call(function () {
      return _await(getPropertyLocales(_this5), function (locales) {
        const localizer = CategoryLocalizerFactory(locales);
        const updatedProps = localizer.applyDefaultLocalizations(category);
        const req = new _this5.client.Request(`/categories`, updatedProps, fields);
        req.parse = Category.fromJson;
        req.serialize = Category.serialize;
        return _this5.client.post(req);
      });
    });
  }

  editWithLocalization(categoryId
  /*: string*/
  )
  /*: Promise<Location>*/
  {
    const _this6 = this;

    return _call(function () {
      return _await(Promise.all([_this6.details(categoryId), _this6.getLocalizations(categoryId).then(r => r.items), getPropertyLocales(_this6)]), function ([category, localizations, locales]) {
        return CategoryLocalizerFactory(locales).setLocalizations(category, localizations);
      });
    });
  }

  update(instance
  /*: Category*/
  , updates
  /*: Category*/
  ) {
    const _this7 = this;

    return _call(function () {
      if (!instance.id) throw new Error('Missing required Category property: id');
      const categoryId = instance.id;
      return _await(getPropertyLocales(_this7), function (locales) {
        const localizer = CategoryLocalizerFactory(locales);
        const updatedProps = diff(instance, localizer.applyDefaultLocalizations(updates));
        const req = new _this7.client.Request(`/categories/${categoryId}`, updatedProps, fields);
        req.parse = Category.fromJson;
        req.serialize = Category.serialize;
        return _await(_this7.client.patch(req), function (updatedCategory) {
          // Update Localizations
          return _await(_this7.updateLocalizations(categoryId, localizer.getLocalizations(updates)), function () {
            return updatedCategory;
          });
        });
      });
    });
  }

  updateLocalizations(categoryId, localizations) {
    const _this8 = this;

    return _call(function () {
      return Promise.all(localizations.map(localization => _this8.setLocalization(categoryId, localization)));
    });
  }

  getLocalizations(categoryId
  /*: string*/
  )
  /*: Promise<PagedList<any>>*/
  {
    const _this9 = this;

    return _call(function () {
      const ALL_LOCALE_FIELDS = ['id', 'type', 'modelId', 'locale', 'content', 'priority'];
      const path = `/categories/${categoryId}/localizations`;
      const req = new _this9.client.Request(path, {}, ALL_LOCALE_FIELDS);
      req.parse = CategoryLocalizationDictionary.fromJson;
      return _await(_this9.client.get(req));
    });
  }

  setLocalization(categoryId, localization)
  /*: Promise<any>*/
  {
    const _this10 = this;

    return _call(function () {
      const {
        locale,
        content
      } = localization;
      const setFields = ['id'];
      const path = `/categories/${categoryId}/localizations`;
      const params = {
        locale,
        content
      };
      const req = new _this10.client.Request(path, params, setFields);
      req.serialize = CategoryLocalizationDictionary.serialize;
      return _await(_this10.client.post(req));
    });
  }

  getValidations(categoryId
  /*: string*/
  )
  /*: Promise<any>*/
  {
    const _this11 = this;

    return _call(function () {
      const getFields = [];
      const path = `/categories/${categoryId}/validation`;
      const req = new _this11.client.Request(path, {}, getFields);
      return _await(_this11.client.get(req));
    });
  }

  delete(categoryId
  /*: string*/
  )
  /*: Promise<any>*/
  {
    const _this12 = this;

    return _call(function () {
      const req = new _this12.client.Request(`/categories/${categoryId}`, {}, []);
      return _await(_this12.client.delete(req));
    });
  }

}

module.exports = CategoryRepo;